import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { IFikoParametre, IFikoParametreGrup, ParamTip } from './IFikoKnowledge';

const GECERLI_AD = /^[A-Za-z_][A-Za-z0-9_]*$/;

export class FikoParametreDeposu {
  parametreler: IFikoParametre[] = [];
  gruplar: IFikoParametreGrup[] = [];

  getId(id: string) { return this.parametreler.find(p => p.id === id); }
  getAd(ad: string) { return this.parametreler.find(p => p.ad === ad); }
  getFeatAlan(featId: string, alan: string) { return this.parametreler.find(p => p.feat?.featId === featId && p.feat?.alan === alan); }

  parametreEkle(p: Partial<IFikoParametre> & { ad: string; tip: ParamTip; deger: any }): IFikoParametre {
    if (!GECERLI_AD.test(p.ad)) throw new Error(`Geçersiz parametre adı: "${p.ad}" (harf/altçizgi ile başlamalı, boşluksuz)`);
    if (this.getAd(p.ad)) throw new Error(`"${p.ad}" adında parametre zaten var`);
    const yeni: IFikoParametre = { id: new FikoYTId().toString(), ad: p.ad, tip: p.tip, deger: p.deger, formul: p.formul, birim: p.birim, aciklama: p.aciklama, kilitli: p.kilitli, grupId: p.grupId, feat: p.feat };
    this.parametreler.push(yeni);
    return yeni;
  }

  parametreSil(id: string): void { this.parametreler = this.parametreler.filter(p => p.id !== id); }

  adDegistir(id: string, yeniAd: string): void {
    const p = this.getId(id); if (!p) return;
    if (!GECERLI_AD.test(yeniAd)) throw new Error(`Geçersiz ad: "${yeniAd}"`);
    if (this.getAd(yeniAd) && this.getAd(yeniAd) !== p) throw new Error(`"${yeniAd}" zaten var`);
    const eski = p.ad; p.ad = yeniAd;
    const esc = (x: string) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const btRe = new RegExp('`' + esc(eski) + '`', 'g');                                  // backtick'li referans
    const bareRe = /^[A-Za-z_][A-Za-z0-9_]*$/.test(eski) ? new RegExp('\\b' + esc(eski) + '\\b', 'g') : null;  // basit referans
    const yeniRef = /^[A-Za-z_][A-Za-z0-9_]*$/.test(yeniAd) ? yeniAd : '`' + yeniAd + '`';
    for (const q of this.parametreler) {
      if (!q.formul) continue;
      let f = q.formul.replace(btRe, yeniRef);
      if (bareRe) f = f.replace(bareRe, yeniRef);
      q.formul = f;
    }
  }

  featAlanYayinla(featId: string, featAd: string, alan: string, etiket: string, tip: ParamTip, deger: any, grupId?: string): IFikoParametre {
    const v = this.getFeatAlan(featId, alan);
    // Mevcut parametre: SADECE alan dışarıdan (feature dialogu) değiştiyse senkronla.
    // _sonYazilan = parametrenin alana en son yazdığı değer; eşitse kullanıcının workbench/f(x) değişikliğini EZME.
    if (v) { if (!v.formul && deger !== v._sonYazilan) v.deger = deger; return v; }
    const ad = this.benzersizAd(`${featAd}\\${etiket}`);
    const yeni: IFikoParametre = { id: new FikoYTId().toString(), ad, tip, deger, feat: { featId, alan }, grupId };
    this.parametreler.push(yeni); return yeni;
  }
  featKaldir(featId: string): void { this.parametreler = this.parametreler.filter(p => p.feat?.featId !== featId); }

  /** Bir feature için otomatik grup (featId ile işaretli) bul/oluştur; feature adı değişince grup adını güncelle. */
  featGrupAl(featId: string, ad: string): IFikoParametreGrup {
    let g = this.gruplar.find(x => x.featId === featId);
    if (!g) { g = { id: new FikoYTId().toString(), ad, featId }; this.gruplar.push(g); }
    else if (g.ad !== ad) g.ad = ad;
    return g;
  }
  /** Artık var olmayan feature'ların otomatik gruplarını temizle. */
  featGruplariTemizle(canliFeatIds: Set<string>): void {
    this.gruplar = this.gruplar.filter(g => !g.featId || canliFeatIds.has(g.featId));
  }

  private benzersizAd(taban: string): string {
    if (!this.getAd(taban)) return taban; let i = 2; while (this.getAd(`${taban}_${i}`)) i++; return `${taban}_${i}`;
  }

  grupEkle(ad: string, ustGrupId?: string): IFikoParametreGrup {
    const g: IFikoParametreGrup = { id: new FikoYTId().toString(), ad, ustGrupId };
    this.gruplar.push(g); return g;
  }
  grupSil(id: string): void {
    const g = this.gruplar.find(x => x.id === id); if (!g) return;
    for (const p of this.parametreler) if (p.grupId === id) p.grupId = g.ustGrupId;
    for (const c of this.gruplar) if (c.ustGrupId === id) c.ustGrupId = g.ustGrupId;
    this.gruplar = this.gruplar.filter(x => x.id !== id);
  }
  tasiParametre(paramId: string, hedefGrupId?: string): void { const p = this.getId(paramId); if (p) p.grupId = hedefGrupId; }
  tasiGrup(grupId: string, hedefGrupId?: string): void {
    if (grupId === hedefGrupId) throw new Error('Grup kendi içine taşınamaz');
    let u = hedefGrupId;
    while (u) { if (u === grupId) throw new Error('Döngüsel grup taşıma engellendi'); u = this.gruplar.find(g => g.id === u)?.ustGrupId; }
    const g = this.gruplar.find(x => x.id === grupId); if (g) g.ustGrupId = hedefGrupId;
  }
}
